import { Dispatch, SetStateAction, useState } from 'react';
import { Button } from 'src/components/atoms';
import { CategoryType } from 'src/graphql';
import { DisableCategoryModal } from '../DisableCategoryModal';
import { CategoryFooterStyled } from './CategoryFooter.styles';

interface Props {
  currentCategory: CategoryType | null;
  setUpdateCategoryModalOpen: Dispatch<SetStateAction<boolean>>;
  saveCategory: () => void;
  isCurrentCategory: boolean;
  isSaveDisabled: boolean;
  isCtaDisabled?: boolean;
}

export const CategoryFooter = ({
  saveCategory,
  currentCategory,
  isCurrentCategory,
  isSaveDisabled,
  isCtaDisabled = false,
  setUpdateCategoryModalOpen,
}: Props) => {
  const [disableModalOpen, setDisableModalOpen] = useState(false);

  const handleSaveCategoryClick = () => {
    const categoryIsBeingDisabled =
      isCurrentCategory &&
      currentCategory &&
      !currentCategory.isReportedCategory &&
      !currentCategory.isDeterminedCategory;

    if (isCurrentCategory) {
      if (categoryIsBeingDisabled) {
        setDisableModalOpen(true);
      } else {
        saveCategory();
      }
    }
  };

  const handleSaveCategory = () => {
    setDisableModalOpen(false);
    saveCategory();
  };

  return (
    <CategoryFooterStyled>
      <Button
        size="medium"
        variant="secondary"
        width="190px"
        onClick={() => setUpdateCategoryModalOpen(true)}
        data-testid="update-category-details"
        disabled={isCtaDisabled}
        noTextWrap
      >
        Update category details
      </Button>

      <Button
        size="medium"
        variant="primary"
        width="140px"
        onClick={handleSaveCategoryClick}
        data-testid="save-category"
        disabled={isSaveDisabled}
      >
        Save
      </Button>
      <DisableCategoryModal
        open={disableModalOpen}
        setOpen={setDisableModalOpen}
        onCancel={() => setDisableModalOpen(false)}
        onConfirm={handleSaveCategory}
      />
    </CategoryFooterStyled>
  );
};
